/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PersonDetail {
  addressId?: number;
  badge?: string;
  badgeId?: number;
  birthday?: Date;
  businessUnitId?: number;
  city?: string;
  cityCode?: number;
  couponName?: string;
  cpf?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  facebookAccessToken?: string;
  facebookId?: number;
  glampointsMultiplier?: number;
  hexColorCode?: string;
  iconUrl?: string;
  instagram?: string;
  lastName?: string;
  name?: string;
  neighborhood?: string;
  newsletterOptIn?: boolean;
  personId?: number;
  personStatus?: number;
  personType?: string;
  personTypeId?: number;
  phone?: string;
  postalCode?: string;
  rewardBalance?: number;
  state?: string;
  stateCode?: number;
  street?: string;
  streetExtensions?: string;
  streetNumber?: string;
  urlImageProfile?: string;
  username?: string;
}
